import { createTheme, alpha } from "@mui/material/styles";
import { perlColors, perlTypography, perlSpacing } from "./tokens";

// MUI theme built from PERL tokens
export const theme = createTheme({
  palette: {
    mode: "dark",
    primary: { main: perlColors.brandColor },
    background: {
      default: perlColors.background,
      paper: perlColors.surface,
    },
    text: {
      primary: perlColors.textPrimary,
      secondary: perlColors.textSecondary,
    },
    divider: perlColors.border,
  },

  typography: {
    fontFamily: perlTypography.family,
    h5: perlTypography.title,
    body1: perlTypography.paragraph,
    body2: perlTypography.labelSmall,
  },

  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontFamily: perlTypography.family,
          fontSize: "1rem",
          fontWeight: 600,
          borderRadius: "999px",
          backgroundColor: perlColors.brandColor,
          color: perlColors.black,
          paddingInline: perlSpacing.buttonPaddingX,
          paddingBlock: perlSpacing.buttonPaddingY,
          "&:hover": {
            backgroundColor: alpha(perlColors.brandColor, 0.8),
            color: perlColors.black,
          },
          "&:disabled": {
            backgroundColor: perlColors.textSecondary,
            color: perlColors.black,
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            fontFamily: perlTypography.family,
            fontSize: "16px",
            fontWeight: 400,
            color: perlColors.textPrimary,
            backgroundColor: perlColors.surface,
            borderRadius: "8px",
            "& fieldset": {
              borderColor: perlColors.border,
            },
            "&:hover fieldset": {
              borderColor: alpha(perlColors.textPrimary, 0.3),
            },
            "&.Mui-focused fieldset": {
              borderColor: perlColors.brandColor,
              borderWidth: "2px",
            },
          },
          "& .MuiInputLabel-root": {
            fontFamily: perlTypography.family,
            fontSize: "16px",
            fontWeight: 400,
            color: perlColors.textSecondary,
            "&.Mui-focused": {
              color: perlColors.brandColor,
            },
          },
          "& .MuiInputBase-input::placeholder": {
            color: perlColors.textSecondary,
            opacity: 0.7,
          },
        },
      },
    },
    MuiSlider: {
      styleOverrides: {
        root: {
          color: perlColors.brandColor,
          height: 1,
          "& .MuiSlider-thumb": {
            backgroundColor: perlColors.brandColor,
            height: 15,
            width: 15,
            "&:hover": {
              boxShadow: `0px 0px 0px 8px ${alpha(perlColors.brandColor, 0.16)}`,
            },
          },
          "& .MuiSlider-track": {
            backgroundColor: perlColors.brandColor,
            height: 1,
          },
          "& .MuiSlider-rail": {
            backgroundColor: alpha(perlColors.textSecondary, 0.3),
            height: 1,
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontFamily: perlTypography.family,
          fontSize: "0.875rem",
          fontWeight: 500,
          borderRadius: "8px",
          backgroundColor: alpha(perlColors.white, 0.08),
          color: perlColors.textPrimary,
          border: `1px solid ${perlColors.border}`,
          "&:hover": {
            backgroundColor: alpha(perlColors.white, 0.12),
          },
          "& .MuiChip-deleteIcon": {
            color: perlColors.textSecondary,
            "&:hover": {
              color: perlColors.textPrimary,
            },
          },
        },
        filled: {
          backgroundColor: alpha(perlColors.brandColor, 0.16),
          color: perlColors.textPrimary,
          border: `1px solid ${alpha(perlColors.brandColor, 0.3)}`,
          "&:hover": {
            backgroundColor: alpha(perlColors.brandColor, 0.24),
          },
        },
        outlined: {
          backgroundColor: "transparent",
          borderColor: perlColors.border,
          "&:hover": {
            backgroundColor: alpha(perlColors.white, 0.04),
          },
        },
        colorSuccess: {
          backgroundColor: alpha("#4caf50", 0.16),
          color: "#4caf50",
          border: `1px solid ${alpha("#4caf50", 0.3)}`,
        },
      },
    },
  },

  // Custom key for PERL tokens
  custom: {
    perlColors,
    perlTypography,
    perlSpacing,
  },
});
